import type { FC } from "react";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import { useRecalculateRevenueShareReportMutation } from "@/admin/entities/revenueShareReports";

interface RecalculateRevenueShareReportButtonProps {
  reportId: string;
  onCompleted?: () => void;
}

/** Ручной пересчёт: доступен только у черновика, бэкенд это проверяет. */
export const RecalculateRevenueShareReportButton: FC<
  RecalculateRevenueShareReportButtonProps
> = ({ reportId, onCompleted }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [recalculate, { loading }] = useRecalculateRevenueShareReportMutation({
    onCompleted: () => {
      enqueueSnackbar("Отчёт пересчитан", { variant: "success" });
      onCompleted?.();
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });

  return (
    <Button
      size="small"
      disabled={loading}
      onClick={(event) => {
        event.stopPropagation();
        void recalculate({ variables: { id: reportId } });
      }}
    >
      Пересчитать
    </Button>
  );
};
